import { Button, IconButton, Typography } from '@material-ui/core'
import React, { Fragment, useState } from 'react'
import { DeleteOutlineOutlined } from '@material-ui/icons'
import LinearProgress from '@material-ui/core/LinearProgress'
import PropTypes from 'prop-types'
import { API_HOST } from '../../src/constants'
import { useAuth } from '../context/useFetch'

const FILENAME_MAX_LENGTH = 48

export const UploadProgress = ({ field, filename, updateHandler, type, title, path, paramName, children, alternativeProgress }) => {
  let inputFile = null

  const auth = useAuth()

  const [isUploading, setIsUploading] = useState(false)
  const [fileName, setFileName] = useState(filename)
  const [loadSize, setLoadSize] = useState(0)
  const [progressUpload, setProgressUpload] = useState(0)
  const [totalSize, setTotalSize] = useState(0)
  const upload = async (file) => {
    setIsUploading(true)
    const formData = new FormData()
    formData.append(paramName, file, file.name)
    const xhr = new XMLHttpRequest()
    xhr.responseType = 'json'
    xhr.onload = function onload() {
      updateHandler()
      setIsUploading(false)
    }
    xhr.upload.onprogress = function onprogress(event) {
      setLoadSize(event.loaded)
      setProgressUpload((event.loaded * 100) / event.total)
      setTotalSize(event.total)
    }

    xhr.open('PUT', `//${API_HOST()}${path}`, true)

    Object.entries(auth.authHeaders()).forEach(([key, value]) => {
      xhr.setRequestHeader(key, value)
    })
    xhr.send(formData)
  }
  const normalizedFileName = () => `${fileName.replace(/___\d+___/, '').substring(0, FILENAME_MAX_LENGTH)}...`
  const progressInformations = () => `${progressUpload.toFixed(2)}% - ${(loadSize / 1000000).toFixed(2)}
      de ${(totalSize / 1000000).toFixed(2)} Mo`
  return (
    <React.Fragment>
      <React.Fragment>
        {children(() => {
          inputFile.click()
        })}
      </React.Fragment>
      <React.Fragment>
        <input
          ref={(node) => {
            inputFile = node
          }}
          type={'file'}
          accept={type}
          onChange={({ target: { files } }) => {
            setFileName(files[0].name)
            upload(files[0]).catch((error) => console.log(error))
          }}
          style={{ display: 'none' }}
        />
      </React.Fragment>
      {isUploading && (
        <div>
          {alternativeProgress && alternativeProgress(progressUpload.toFixed(2))}
          {!alternativeProgress && (
            <Fragment>
              <LinearProgress variant="determinate" value={progressUpload} />
              <Typography style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '8px' }}> {progressInformations()} </Typography>
            </Fragment>
          )}
        </div>
      )}
    </React.Fragment>
  )
}

UploadProgress.proptypes = {
  field: PropTypes.string.isRequired,
  filename: PropTypes.string.isRequired,
  updateHandler: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}
